import { styled } from "styled-system/jsx";
import { SystemStyleObject } from "styled-system/types";

export const InfoCustom = ({ ...props }: SystemStyleObject) => {
  return (
    <styled.svg
      width="116"
      height="85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="info"
      {...props}
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="#CCE0FF"
      />
      <path
        d="M12 11.5V16.5M12 7.51L12.01 7.49889M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#1D7AFC"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </styled.svg>
  );
};
